import { render, staticRenderFns } from "./HCP.vue?vue&type=template&id=cfe51830"
import script from "./HCP.vue?vue&type=script&lang=js"
export * from "./HCP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports